import QueryId from '../users/query-id'

export default QueryId
